<template>
  <el-card v-loading="loading">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-position="top">
      <el-row :gutter="20">
        <el-col :span="24">
          <copy-from
            :dataForm="dataForm"
            :options="packageList"
            :labelFormatter="item => `[${item.packageCode}]${item.packageName}`"
            @copyFromTrigger="copyFromTrigger"
          />
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Package Code" prop="packageCode">
            <el-input v-model="dataForm.packageCode" clearable placeholder="PKG-001" v-regexFilter="halfWidthRegex"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Country" prop="country">
            <el-select v-model="dataForm.country" filterable clearable placeholder="Country" class="wdb100" @change="countryChange">
              <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="businessType">
            <span slot="label">
              Business Type
              <el-popover trigger="hover" content="Select country first">
                <i slot="reference" class="el-icon-info"></i>
              </el-popover>
            </span>
            <el-select v-model="dataForm.businessType" clearable placeholder="Select Business Type" class="fluid-width" @change="setServiceOptions">
              <el-option v-for="item in supportBusinessTypesOptions" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="supplierId">
            <span slot="label">
              Supplier
              <el-popover trigger="hover" content="Select country first">
                <i slot="reference" class="el-icon-info"></i>
              </el-popover>
            </span>
            <el-select v-model="dataForm.supplierId" clearable placeholder="Select Supplier" class="fluid-width" @change="setServiceOptions">
              <el-option v-for="item in supplierOptions" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Package Name (EN)" prop="packageName">
            <el-input v-model="dataForm.packageName" clearable placeholder="Package Name (EN)" v-regexFilter="halfWidthRegex"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Package Name (CN)" prop="packageNameCn">
            <el-input v-model="dataForm.packageNameCn" clearable placeholder="Package Name (CN)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Package Name (Local)" prop="packageNameLocal">
            <el-input v-model="dataForm.packageNameLocal" clearable placeholder="Package Name (Local)"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Applicable Person (EN)" prop="applicablePerson">
            <el-input
              v-model="dataForm.applicablePerson"
              type="textarea"
              :rows="3"
              resize="none"
              clearable
              placeholder="Applicable Person (EN)"
              v-regexFilter="halfWidthRegex"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Applicable Person (CN)" prop="applicablePersonCn">
            <el-input
              v-model="dataForm.applicablePersonCn"
              type="textarea"
              :rows="3"
              resize="none"
              clearable
              placeholder="Applicable Person (CN)"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item label="Currency" prop="currency">
            <el-select v-model="dataForm.currency" filterable clearable placeholder="Select Currency" class="wdb100" @change="setServiceOptions">
              <el-option v-for="item in currencyList" :key="item.currency" :label="item.currency" :value="item.currency"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Price" prop="price">
            <el-input v-model="dataForm.price" v-positivePoint placeholder="0.00">
              <template slot="prefix">{{ currencySymbolFormat(dataForm.currency) }}</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="Services" prop="serviceIds">
            <select-Service
              :businessType="dataForm.businessType"
              :supplierId="dataForm.supplierId"
              :currency="dataForm.currency"
              :checkboxOptionList="serviceOptions"
              :echoSelectedServiceList="echoSelectedServiceList"
              v-model="dataForm.serviceIds"
            ></select-Service>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item label="Sort No." prop="orderNum">
            <el-input v-model="dataForm.orderNum" clearable placeholder="Order Number" v-positiveInteger></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Status" prop="status">
            <el-radio-group v-model="dataForm.status">
              <el-radio :label="0">Disable</el-radio>
              <el-radio :label="1">Enable</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="pt16">
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">Submit</el-button>
        <el-button @click="() => $router.replace('/sys/pkg/plan')">Back</el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import SelectService from "./components/SelectService";
import CopyFrom from "@/components/CopyFrom";
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin],
  components: {
    CopyFrom,
    SelectService,
  },
  data() {
    return {
      dataId: null,
      loading: false,
      submitLoading: false,
      dataForm: {
        packageCode: "",
        businessType: "",
        packageName: "",
        packageNameCn: "",
        packageNameLocal: "",
        applicablePerson: "",
        applicablePersonCn: "",
        currency: "",
        price: "",
        country: "",
        supplierId: "",
        serviceIds: [],
        orderNum: "",
        status: 1,
      },
      dataRule: {
        packageCode: [{ required: true, message: "please enter", trigger: "submit" }],
        businessType: [{ required: true, message: "please select", trigger: "submit" }],
        packageName: [{ required: true, message: "please enter", trigger: "submit" }],
        packageNameCn: [{ required: true, message: "please enter", trigger: "submit" }],
        currency: [{ required: true, message: "please select", trigger: "submit" }],
        price: [{ required: true, message: "please enter", trigger: "submit" }],
        country: [{ required: true, message: "please select", trigger: "submit" }],
        supplierId: [{ required: true, message: "please select", trigger: "submit" }],
      },
      supplierOptions: [],
      allSupplierOptions: [],
      supportBusinessTypesOptions: [],
      serviceOptions: [],
      allServiceOptions: [],
      echoSelectedServiceList: [], // 回显时使用的已选中服务信息列表
      packageList: [],
    };
  },
  computed: {
    ...mapState("constant", ["countryList"]),
    ...mapState("currency", ["currencyList"]),
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.allSupplierOptions = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取服务列表
    getServiceList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/service/list", {
            params: {
              status: 1,
            },
          })
          .then(res => {
            this.allServiceOptions = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取套餐列表
    getPackageList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/package/list")
          .then(res => {
            this.packageList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取详情
    getDetail() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`/admin/package/${this.dataId}`)
          .then(res => {
            const resData = { ...res.data };
            resData.supplierId = resData.supplier?.id || "";
            resData.serviceIds = resData.serviceList.map(item => item.id);
            this.echoSelectedServiceList = resData.serviceList;
            this.dataForm = resData;
            this.countryChange("", false);
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 提交表单
    formSubmitRequest() {
      if (this.dataId) {
        return this.$http.put(`/admin/package/${this.dataId}`, this.dataForm);
      } else {
        return this.$http.post("/admin/package", this.dataForm);
      }
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.$router.replace("/sys/pkg/plan");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
    // 设置serviceOptions
    setServiceOptions(val, isNeedReset = true) {
      const { businessType, currency, supplierId } = this.dataForm;
      this.serviceOptions = this.allServiceOptions.filter(
        item => item.businessTypeList?.includes(businessType) && item.currency === currency && item.supplier?.id === supplierId,
      );
      if (isNeedReset) {
        // 重置
        this.echoSelectedServiceList = [];
        this.$set(this.dataForm, "serviceIds", []);
      }
    },
    // country选中时触发
    countryChange(val, isNeedReset = true) {
      const { country } = this.dataForm;
      // 供应商列表
      this.supplierOptions = this.allSupplierOptions.filter(item => item.country == country);
      // 支持的服务列表
      const currentCountry = this.countryList.find(ele => ele.value == country);
      this.supportBusinessTypesOptions = currentCountry?.supportBusinessTypesList || [];
      // 是否重置选中值
      if (isNeedReset) {
        this.$set(this.dataForm, "supplierId", "");
        this.$set(this.dataForm, "businessType", "");
      }
      // 设置serviceOptions
      this.setServiceOptions("", isNeedReset);
    },
    // 接收复制完成的数据
    copyFromTrigger(originalData, newDataForm) {
      newDataForm.supplierId = originalData?.supplier?.id || "";
      newDataForm.serviceIds = originalData.serviceList.map(item => item.id);
      this.echoSelectedServiceList = originalData.serviceList;
      this.dataForm = newDataForm;
      this.countryChange("", false);
    },
  },
  async activated() {
    this.loading = true;
    this.submitLoading = false;
    this.$refs.dataForm.resetFields();
    this.dataId = this.$route.params?.id || "";
    try {
      // 获取供应商列表
      await this.getSupplierList();
      // 获取服务列表
      await this.getServiceList();
      // 获取详情
      if (this.dataId) await this.getDetail();
      // 获取套餐列表
      await this.getPackageList();
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item {
    margin-bottom: 20px !important;

    .el-form-item__label {
      padding: 0px !important;
      line-height: 30px !important;
    }

    .el-form-item__error {
      padding-top: 0px !important;
    }
  }

  .el-input--prefix {
    .el-input__inner {
      padding-left: 40px !important;
    }
  }
}
</style>
